import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { bucketClass, bucketLabel, fmtDate, fmtHours, fmtUsd } from "./labels";

const PAGE = 100;

export function LeadsTable({ leads, loading }) {
  const [visible, setVisible] = useState(PAGE);
  useEffect(() => { setVisible(PAGE); }, [leads]);
  if (loading) return <div className="text-sm text-clay-600 p-6">Cargando…</div>;
  if (!leads.length) return <div className="border border-dashed border-clay-300 p-10 text-center text-sm text-clay-600" data-testid="kimkim-empty">No hay leads con estos filtros.</div>;
  const shown = leads.slice(0, visible);
  return (
    <div className="border border-clay-300 bg-white overflow-x-auto">
      <table className="w-full text-sm" data-testid="kimkim-leads-table">
        <thead className="bg-clay-100 border-b border-clay-300 text-left text-[11px] uppercase tracking-wider text-clay-700">
          <tr>
            <th className="px-3 py-2 font-medium">Viajero</th>
            <th className="px-3 py-2 font-medium">Destino</th>
            <th className="px-3 py-2 font-medium">Solicitud</th>
            <th className="px-3 py-2 font-medium">Viaje</th>
            <th className="px-3 py-2 font-medium text-right">Pax</th>
            <th className="px-3 py-2 font-medium text-right">Presup./pers.</th>
            <th className="px-3 py-2 font-medium">Agente</th>
            <th className="px-3 py-2 font-medium text-right">1ª resp.</th>
            <th className="px-3 py-2 font-medium text-right">Msgs</th>
            <th className="px-3 py-2 font-medium">Resultado</th>
          </tr>
        </thead>
        <tbody>
          {shown.map((l) => {
            const c = l.categories || {};
            return (
              <tr key={l.lead_id} className="border-t border-clay-200 hover:bg-clay-50" data-testid={`kimkim-lead-row-${l.lead_id}`}>
                <td className="px-3 py-2">
                  <Link to={`/admin/kimkim-leads/${l.lead_id}`} className="font-medium hover:text-terracotta" data-testid={`kimkim-lead-link-${l.lead_id}`}>{l.traveler_name || l.kimkim_id}</Link>
                  {l.ai_done && <Sparkles size={11} className="inline ml-1.5 text-terracotta" title="Analizado con IA"/>}
                </td>
                <td className="px-3 py-2 text-clay-800">
                  <div className="max-w-[220px] truncate" title={l.trip_name || ""}>{l.trip_name || (l.destinations || []).join(", ") || "—"}</div>
                  {l.trip_name && (l.destinations || []).length ? <div className="text-[11px] text-clay-500">{l.destinations.join(", ")}</div> : null}
                </td>
                <td className="px-3 py-2 tabular whitespace-nowrap">{fmtDate(c.requested_at)}</td>
                <td className="px-3 py-2 tabular whitespace-nowrap">{l.trip_start ? `${fmtDate(l.trip_start)} · ${c.duration_days || "?"} d` : "—"}</td>
                <td className="px-3 py-2 text-right tabular">{l.travelers ?? "—"}</td>
                <td className="px-3 py-2 text-right tabular">{fmtUsd(c.budget_pp_usd)}</td>
                <td className="px-3 py-2">{l.agent_name || <span className="text-clay-500">Sin asignar</span>}</td>
                <td className="px-3 py-2 text-right tabular">{fmtHours(c.first_response_hours)}</td>
                <td className="px-3 py-2 text-right tabular">{c.messages_count ?? 0}</td>
                <td className="px-3 py-2"><span className={`inline-block border px-2 py-0.5 text-[11px] ${bucketClass(l.bucket)}`}>{bucketLabel(l.bucket)}</span></td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="flex items-center justify-between px-3 py-2 border-t border-clay-200 text-[11px] text-clay-600">
        <span data-testid="kimkim-table-count">{Math.min(visible, leads.length)} de {leads.length} leads</span>
        {visible < leads.length && (
          <button onClick={() => setVisible((v) => v + PAGE)} className="uppercase tracking-wider hover:text-terracotta" data-testid="kimkim-table-more">Mostrar {Math.min(PAGE, leads.length - visible)} más</button>
        )}
      </div>
    </div>
  );
}
